
import { Mode, ReservationBrowsingPeriod } from "models/Mode";
import { TimeRange } from "models/Reservation";

import { getDateFormatted } from "../date/getDateFormatted";

export function getMapEndDate(mode: Mode, browsingPeriod: ReservationBrowsingPeriod, queryData: TimeRange): string {
    switch (mode) {
        case Mode.RESERVATION_BROWSING:
        case Mode.RESERVATION_PREVIEW:
        case Mode.RESERVATION_CREATION:
        case Mode.RESERVATION_EDIT:
            switch (browsingPeriod) {
                case ReservationBrowsingPeriod.EVENING:
                    return getDateFormatted({ date: queryData.start, hour: 24 });

                case ReservationBrowsingPeriod.MORNING:
                    return getDateFormatted({ date: queryData.start, hour: 17 });

                default:
                    return queryData.end;
            }

        case Mode.PRINTING:
            return getDateFormatted({ date: queryData.start, hour: 24 });

        default:
            return queryData.end;
    }
}
